<template>
  <div class="HeaderBar">
    <div>
      <div class="logo_sty">
        <div class="header_bar_log"></div>
        <div class="header_bar_sty">
          山东省生态环境科技成果转化和环保产业发展综合服务平台
        </div>
        <div class="user_info" v-if="userinfo">
          <img src="data:image/png;base64,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" style="width: 1.5vw; cursor: pointer;">
          <span class="app-user-info-name">
          <router-link :to="{ path: '/personal'}">
            <el-tooltip class="item" effect="dark" :content="userinfo.userName" placement="top-end">
              <div class="user_name">{{ userinfo.userName }}</div>
            </el-tooltip>
          </router-link>
          </span>
          <el-popover class="my_popover" placement="bottom" trigger="click">
            <p style="margin: 0">
              <span class="app-user-info-name my_header_span" @click="logout()">退出登录</span>
            </p>
            <i slot="reference" class="el-icon-arrow-down"></i>
          </el-popover>
          <span class="person_page" @click="gotoPage('/personal')"> | 个人中心</span>
        </div>
        <div class="user_info" v-else>
          <router-link :to="{ path: '/login',query:{'flag':'login'}}">登录</router-link>
          <span> | </span>
          <router-link :to="{ path: '/login',query:{'flag':'register'}}">注册</router-link>
        </div>
      </div>
      <div class="menu_p">
        <template v-for="item in routerMap" v-if="!item.hidden">
          <div :class="{'menu_div_index':true,'active_menu':item.children[0].meta.key===activePage}" v-if="!item.listFlag"
               @click="gotoPage(item.children[0].path)">
            {{ item.children[0].name }}
          </div>
          <div :class="{'menu_div_index':true,'active_menu':item.meta.key===activePageParent}" v-else>
            <span @click="toScroll(item.meta)">{{ item.name }}</span>
            <div class="menu_child_p">
              <div :class="{'menu_child_item':true,'active_menu':child.meta.key===activePage}" v-for="child in item.children"
                   v-if="!child.hidden" @click="gotoPage(child.path)">
                {{ child.name }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {routerMap} from "@/router/index"
import store from "@/store";
import cache from "@/utils/cache";
import {removeToken} from '@/utils/auth'

export default {
  name: "HeaderBar",
  computed: {
    activePage() {
      return store.getters.activePage;
    },
    activePageParent() {
      return store.getters.activePageParent;
    },
    userinfo() {
      return cache.local.getJSON("userInfo")
    }
  },
  watch: {
    $route(to) {
      this.auto(to);
      // this.activePage = to.path
    }
  },
  data() {
    return {
      routerMap: routerMap
    }
  },
  methods: {
    logout() {
      removeToken()
      window.location.reload();
      cache.local.remove("userInfo")
      /*if (this.$route.path === '/personal') {
        this.$router.push({path: '/login'})
      }*/
    },
    auto(to) {
      let navbar = {
        img: to.meta.img,
      }
      this.$store.dispatch('setNavbar', navbar);
      let breadCrumb = [{path: '/index', name: '首页', meta: {firstName: '首页'}}];
      this.routerMap.forEach(function (route) {
        if (route.children && route.listFlag) {
          route.children.forEach(function (child) {
            if (to.meta.key === child.meta.key) {
              console.log(to)
              console.log(child)
              breadCrumb.push(route)
              breadCrumb.push(child)
              store.dispatch('setBreadCrumb', breadCrumb);
              store.dispatch('setActivePage', child.meta.key);
              store.dispatch('setActivePageParent', child.meta.keyParent);
            }
          })
        } else if (route.children && !route.listFlag) {
          route.children.forEach(function (child) {
            if (to.meta.key === child.meta.key) {
              breadCrumb.push(child)
              console.log(to)
              console.log(child)
              store.dispatch('setBreadCrumb', breadCrumb);
              store.dispatch('setActivePage', child.meta.key);
              store.dispatch('setActivePageParent', 'xxx');
            }
          })
        }
      })
    },
    gotoPage(val) {
      this.$router.push({path: val})
    },
    scrolling() {
      // 滚动条距文档顶部的距离
      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;

      //变量windowHeight是可视区的高度
      let windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;

      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //你想做的事情
      }
      if (scrollStep < 0) {
      } else {
      }
      // 判断是否到了最顶部
      if (scrollTop <= 0) {
        console.log("header 到了最顶部")
      }
    },
    toScroll(meta) {
      let hdb = document.getElementsByClassName("HeaderBar");
      let jH = hdb[0].offsetHeight;
      if (meta.key) {
        let a = document.getElementById(meta.key);
        if (a) {
          let rect = a.getBoundingClientRect();
          let offsetTop = rect.top + window.scrollY;
          let top =offsetTop - jH;
          if(meta.key=='information'){
            top=offsetTop-500;
          }

          window.scrollTo({top: top, behavior: 'smooth'});
        }
      }
    },
    vhToPx(vh) {
      let viewportHeight = window.innerHeight;
      return vh * viewportHeight;
    }
  },
  mounted() {
    this.auto(this.$route);
    window.addEventListener("scroll", this.scrolling);
  }
}
</script>

<style scoped lang="scss">
.HeaderBar {
  width: 100vw;
  position: fixed;
  z-index: 4;
  top: 0;
  background: rgba(0, 0, 0, 0.4);

  .logo_sty {
    float: left;
    flex-flow: row;
    width: 100vw;
    margin-left: 5vw;
    // border: 1px solid red;
    .header_bar_log {
      width: 5vw;
      background: url("~@/assets/images/layout/favicon.png") no-repeat;
      background-size: 100%;
      height: 5vw;
      text-align: left;
      background-position-y: 50%;
      float: left;
    }

    .header_bar_sty {
      margin-top: 1vw;
      height: 3vw;
      font-size: 2vw;
      font-family: DFPLiJinHeiW8-GB;
      font-weight: 550;
      color: #fff;
      float: left;
      //background: url("~@/assets/images/layout/text.png") no-repeat;
      //background-size: 100% 100%;
    }
  }

  .menu_p {
    float: left;
    margin-left: 52vw;
    position: relative;
    top: -0.3vw;

    .active_menu {
      color: #fccd50 !important;
    }

    .menu_div_index {
      display: inline-block;
      font-size: 1.2vw;
      margin-right: 0.8vw;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
      position: relative;
      cursor: pointer;

      .menu_child_p {
        background: rgba(0, 0, 0, 0.49);
        color: #ffffff;
        position: absolute;
        width: 9vw;
        left: -2vw;
        display: none;

        .menu_child_item {
          padding: 10px 0;
        }
      }
    }

    .menu_div_index:hover {
      .menu_child_p {
        display: block;
      }
    }

    .menu_child_item:hover {
      color: #3c9bf1;
    }
  }

  .user_info {
    float: right;
    margin-right: 17vw;
    padding: 1.8vw 0 1.6vw 0;


    .logOut {
      position: relative;
      bottom: 7px;
      cursor: pointer;
    }

    a {
      color: #ffffff;
      font-size: 1vw;
      font-weight: 400;
    }
  }

  .app-user-info-name {
    position: relative;
    top: -0.4vw;
    font-size: 2vw;
    cursor: pointer;
    margin-right: 0.3vw;
    color: #ffffff;
  }

  .user_name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 7vw;
    display: inline-block;
    position: relative;
    top: 0.2vw;
  }

  .el-icon-arrow-down {
    color: #FFFFFF;
    position: relative;
    top: -6px;
  }

  .person_page {
    color: #F7F8F9;
    position: relative;
    bottom: 0.5vw;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.my-el-menu {
  li, li div {
    font-weight: 700;
    font-size: 18px;
  }
}

.el-popover {
  min-width: 100px !important;
}

.my_header_span {
  font-size: 16px;
  color: #6f6f6f;
  cursor: pointer;
  margin-right: 0.3vw;
  padding: 4px 0;
  display: block;
}
</style>
